import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_staging/69ea48f663911b0014c1aa10/careflow/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["RoleProvider"] */ "/home/ubuntu/download_staging/69ea48f663911b0014c1aa10/careflow/src/contexts/RoleContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ea48f663911b0014c1aa10/careflow/src/styles/tailwind.css");
